import React from 'react';

const circularCourses = [
  {
    title: "O Level",
    subtitle: "NIELIT 'O' Level Certification",
    img: "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    description: "NIELIT 'O' Level is a foundation course in computer applications recognized by the Government of India. It provides basic IT literacy and programming skills.",
    details: [
      "Duration: 1 year (minimum)",
      "Eligibility: 10+2 or ITI Certificate",
      "Exam conducted by NIELIT",
      "Covers IT Tools, Internet, Programming, and more",
      "Equivalent to a foundation level course in computer applications"
    ],
    duration: "1 Year",
    price: "₹5,000 - ₹10,000",
    level: "Beginner"
  },
  {
    title: "A Level",
    subtitle: "NIELIT 'A' Level Certification",
    img: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    description: "NIELIT 'A' Level is an advanced course in computer applications equivalent to Advanced Diploma in Computer Applications.",
    details: [
      "Duration: 1 year (after O Level)",
      "Covers advanced programming, DBMS, and software engineering",
      "Includes project work",
      "Recognized by Government and private sector",
      "Equivalent to Advanced Diploma in Computer Applications"
    ],
    duration: "1 Year",
    price: "₹8,000 - ₹15,000",
    level: "Intermediate"
  },
  {
    title: "BCA",
    subtitle: "Bachelor of Computer Applications",
    img: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    description: "3-year undergraduate program focusing on computer applications and software development.",
    details: [
      "Duration: 3 years (6 semesters)",
      "Eligibility: 10+2 with Mathematics",
      "Covers programming, DBMS, networking, web technologies",
      "Includes projects and internships",
      "Pathway to MCA or IT jobs"
    ],
    duration: "3 Years",
    price: "₹50,000 - ₹1,50,000 per year",
    level: "Undergraduate"
  },
  {
    title: "MCA",
    subtitle: "Master of Computer Applications",
    img: "https://images.unsplash.com/photo-1541178735493-479c1a27ed24?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    description: "2-year postgraduate program for advanced computer applications and software development.",
    details: [
      "Duration: 2 years (4 semesters)",
      "Eligibility: Bachelor's degree with Mathematics",
      "Advanced topics in programming, algorithms, AI, etc.",
      "Includes dissertation/project work",
      "Prepares for senior IT positions"
    ],
    duration: "2 Years",
    price: "₹75,000 - ₹2,00,000 per year",
    level: "Postgraduate"
  },
  {
    title: "ADCA",
    subtitle: "Advanced Diploma in Computer Applications",
    img: "https://images.unsplash.com/photo-1517842645767-c639042777db?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    description: "1-year professional course covering advanced computer applications and office automation.",
    details: [
      "Duration: 1 year",
      "Covers Office, Accounting, Programming, Web Design",
      "Hands-on training with live projects",
      "Job-oriented curriculum",
      "Placement assistance available"
    ],
    duration: "1 Year",
    price: "₹15,000 - ₹30,000",
    level: "Intermediate"
  },
  {
    title: "DCA",
    subtitle: "Diploma in Computer Applications",
    img: "https://images.unsplash.com/photo-1554224155-6726-b3ff858f?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    description: "6-12 months basic course in computer applications and office automation.",
    details: [
      "Duration: 6-12 months",
      "Basic computer operations and office software",
      "Internet and email fundamentals",
      "Simple programming concepts",
      "Ideal for beginners and job seekers"
    ],
    duration: "6-12 Months",
    price: "₹5,000 - ₹15,000",
    level: "Beginner"
  },
  {
    title: "Free Training",
    subtitle: "Government Skill Development Programs",
    img: "https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    description: "Free computer training programs sponsored by government for skill development.",
    details: [
      "Duration: 1-6 months depending on course",
      "Basic to advanced IT skills",
      "Certification provided",
      "Eligibility varies (often for unemployed youth)",
      "Includes placement support"
    ],
    duration: "1-6 Months",
    price: "Free",
    level: "All levels"
  },
  {
    title: "NELLT",
    subtitle: "National English Language & Literature Test",
    img: "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
    description: "The NELLT certification evaluates comprehensive English language and literature proficiency.",
    details: [
      "Assesses reading, writing, listening, and speaking skills",
      "Includes literary analysis components",
      "Recognized by universities nationwide",
      "Three difficulty levels available",
      "Valid for 2 years"
    ],
    duration: "3 hours",
    price: "$150",
    level: "All levels"
  }
];

function CircularCoursesGrid() {
  const [activeIdx, setActiveIdx] = React.useState(null);
  const [showModal, setShowModal] = React.useState(false);
  const [selectedCourse, setSelectedCourse] = React.useState(null);

  const handleInfoClick = (idx, e) => {
    e.stopPropagation();
    setSelectedCourse(circularCourses[idx]);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedCourse(null);
  };

  return (
    <div style={{ background: "#f2f2f2", padding: "40px 0 0 0", position: 'relative' }}>
      <style>{`
        .circular-courses-title {
          color: #cc0066;
          margin-bottom: 50px;
          text-transform: uppercase;
          font-size: 2.5rem;
          text-shadow: 1px 1px 3px rgba(0,0,0,0.1);
          letter-spacing: 2px;
          text-align: center;
        }
        .courses-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 30px;
          max-width: 1000px;
          margin: 0 auto 30px auto;
          padding: 20px;
        }
        .ch-item {
          width: 180px;
          height: 180px;
          border-radius: 50%;
          position: relative;
          cursor: pointer;
          background: linear-gradient(135deg, #cc0066, #a80055);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
        .ch-item:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
        }
        .ch-thumb {
          width: 100%;
          height: 100%;
          background-size: cover;
          background-position: center;
          border-radius: 50%;
          position: absolute;
          box-shadow: inset 0 0 0 10px rgba(255, 255, 255, 0.4);
          transform-origin: 95% 40%;
          transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
          z-index: 2;
          overflow: hidden;
        }
        .ch-thumb:after {
          content: '';
          width: 10px;
          height: 10px;
          position: absolute;
          border-radius: 50%;
          top: 40%;
          left: 95%;
          margin: -5px 0 0 -5px;
          background: radial-gradient(circle, #0e0e0e 0%, #7d7e7d 100%);
          box-shadow: 0 0 3px rgba(255, 255, 255, 0.9);
          transition: all 0.3s ease;
        }
        .ch-item:hover .ch-thumb {
          transform: rotate(-110deg) scale(1.1);
          box-shadow: inset 0 0 0 5px rgba(255, 255, 255, 0.6);
        }
        .ch-item:hover .ch-thumb:after {
          transform: scale(1.3);
          opacity: 0.8;
        }
        .click-here {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, 20%);
          background: white;
          color: #cc0066;
          padding: 10px 25px;
          border-radius: 30px;
          font-weight: bold;
          opacity: 0;
          transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
          z-index: 3;
          box-shadow: 0 5px 15px rgba(0,0,0,0.2);
          text-transform: uppercase;
          font-size: 14px;
          letter-spacing: 1px;
        }
        .ch-item:hover .click-here {
          opacity: 1;
          transform: translate(-50%, -50%);
        }
        .course-info {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: rgba(204, 0, 102, 0.9);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          opacity: 0;
          transition: all 0.3s ease;
          z-index: 1;
          padding: 20px;
          box-sizing: border-box;
          color: white;
          text-align: center;
          transform: scale(0.8);
        }
        .course-info h3 {
          margin: 0 0 10px 0;
          font-size: 1.5rem;
          text-transform: uppercase;
        }
        .course-info p {
          margin: 0 0 15px 0;
          font-size: 0.9rem;
          line-height: 1.4;
        }
        .info-button {
          background: white;
          color: #cc0066;
          border: none;
          padding: 8px 20px;
          border-radius: 20px;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.2s;
          text-transform: uppercase;
          font-size: 12px;
        }
        .info-button:hover {
          transform: scale(1.05);
          box-shadow: 0 3px 10px rgba(0,0,0,0.2);
        }
        .ch-item.active .ch-thumb {
          transform: rotate(-110deg) scale(0);
          opacity: 0;
        }
        .ch-item.active .click-here {
          opacity: 0;
          transform: translate(-50%, 20%);
        }
        .ch-item.active .course-info {
          opacity: 1;
          transform: scale(1);
        }
        
        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          animation: fadeIn 0.2s ease-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .modal-container {
          background: white;
          border-radius: 10px;
          width: 80%;
          max-width: 800px;
          max-height: 90vh;
          overflow-y: auto;
          padding: 30px;
          position: relative;
          box-shadow: 0 5px 30px rgba(0,0,0,0.3);
          animation: slideUp 0.2s ease-out;
        }
        @keyframes slideUp {
          from { 
            opacity: 0;
            transform: translateY(20px);
          }
          to { 
            opacity: 1;
            transform: translateY(0);
          }
        }
        .modal-close {
          position: absolute;
          top: 15px;
          right: 15px;
          background: #cc0066;
          color: white;
          border: none;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          font-size: 16px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
        }
        .modal-close:hover {
          transform: scale(1.1);
          background: #a80055;
        }
        .modal-header {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
        }
        .modal-image {
          width: 120px;
          height: 120px;
          border-radius: 10px;
          object-fit: cover;
          margin-right: 20px;
        }
        .modal-title {
          color: #cc0066;
          margin: 0;
          font-size: 2rem;
        }
        .modal-subtitle {
          color: #666;
          margin: 5px 0 0 0;
          font-size: 1.2rem;
        }
        .modal-description {
          margin: 20px 0;
          line-height: 1.6;
          color: #333;
        }
        .modal-details {
          background: #f9f9f9;
          padding: 20px;
          border-radius: 8px;
          margin-bottom: 20px;
        }
        .modal-details h4 {
          margin-top: 0;
          color: #cc0066;
          border-bottom: 1px solid #eee;
          padding-bottom: 10px;
        }
        .modal-details ul {
          padding-left: 20px;
        }
        .modal-details li {
          margin-bottom: 8px;
          line-height: 1.5;
        }
        .course-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          margin-bottom: 20px;
        }
        .meta-item {
          background: #f0f0f0;
          padding: 10px 15px;
          border-radius: 5px;
          display: flex;
          align-items: center;
        }
        .meta-label {
          font-weight: bold;
          margin-right: 5px;
          color: #cc0066;
        }
        .enroll-button {
          background: #cc0066;
          color: white;
          border: none;
          padding: 12px 30px;
          border-radius: 30px;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin-top: 20px;
        }
        .enroll-button:hover {
          background: #a80055;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        }
        
        @media (max-width: 600px) {
          .courses-container {
            gap: 16px;
          }
          .ch-item {
            width: 120px;
            height: 120px;
          }
          .modal-container {
            width: 95%;
            padding: 20px 15px;
          }
          .modal-header {
            flex-direction: column;
            text-align: center;
          }
          .modal-image {
            margin-right: 0;
            margin-bottom: 15px;
          }
          .course-meta {
            flex-direction: column;
            gap: 10px;
          }
        }
      `}</style>
      
      <div className="circular-courses-title">OUR COURSES</div>
      <div className="courses-container">
        {circularCourses.map((course, idx) => (
          <div
            key={idx}
            className={`ch-item${activeIdx === idx ? " active" : ""}`}
            onClick={() => setActiveIdx(activeIdx === idx ? null : idx)}
          >
            <div className="ch-thumb" style={{ backgroundImage: `url('${course.img}')` }} />
            <div className="click-here">Click Here</div>
            <div className="course-info">
              <h3>{course.title}</h3>
              <p>{course.subtitle}</p>
              <button 
                className="info-button" 
                onClick={(e) => handleInfoClick(idx, e)}
              >
                Learn More
              </button>
            </div>
          </div>
        ))}
      </div>
      
      {showModal && selectedCourse && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-container" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>×</button>
            <div className="modal-header">
              <img src={selectedCourse.img} alt={selectedCourse.title} className="modal-image" />
              <div>
                <h2 className="modal-title">{selectedCourse.title}</h2>
                <p className="modal-subtitle">{selectedCourse.subtitle}</p>
              </div>
            </div>
            
            <div className="course-meta">
              <div className="meta-item">
                <span className="meta-label">Duration:</span>
                <span>{selectedCourse.duration}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Level:</span>
                <span>{selectedCourse.level}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">Price:</span>
                <span>{selectedCourse.price}</span>
              </div>
            </div>
            
            <p className="modal-description">{selectedCourse.description}</p>
            
            <div className="modal-details">
              <h4>Course Details</h4>
              <ul>
                {selectedCourse.details.map((detail, i) => (
                  <li key={i}>{detail}</li>
                ))}
              </ul>
            </div>
            
            <button className="enroll-button">Enroll Now</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default CircularCoursesGrid;